import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { Category, CategoryList } from 'src/app/shared/model/category.model';
import { Button, ExampleEnum, PopUpTitles } from 'src/app/shared/model/enum';
import { Tag, TagsData} from 'src/app/shared/model/tag.model';
import { CategoryService } from 'src/app/shared/services/category.service';


@Component({
  selector: 'app-add-tags',
  templateUrl: './add-tags.component.html',
  styleUrls: ['./add-tags.component.scss']
})
export class AddTagsComponent implements OnInit {
  @Input() isAddValue: boolean;
  enumButtonName = Button
  fieldValue: TagsData = new TagsData();
  enumPopUpTitles = PopUpTitles;
// fieldValue = Tag
  @Input() selectLabel:string;
  @Input() insertTagsModel = new Tag();
  public enumValues: string[];
  fieldValueList = [
    { id: '1', name: 'Text' },
    { id: '2', name: 'Number' },
    { id: '3', name: 'Date' }
  ]
  ;
  // insertTagsModel = this.fieldValue;
  categories: CategoryList[] = [];
  constructor(public activeModal: NgbActiveModal,
     public  categoryService: CategoryService,  
     public toaster: ToastrService,
     public tabService:TabsService,
     public agGridService: AgGridService,
    ) { 

    }

  ngOnInit(): void {
   this.getAllCategory()
  //  this.enumValues = Object.values(ExampleEnum);
  }
 getNameById(id) {
    const field = this.fieldValueList.find(item => item.id === id);
    return field ? field.name : ''; // Return the name if found, otherwise return null
  }

  addTags() {
    this.insertTagsModel.fieldValue=this.getNameById(this.insertTagsModel.fieldValue);
    this.categoryService.addTagService(this.insertTagsModel).subscribe((res) =>{
      if(res.isSuccess == true) {
        this.toaster.success(res.message)
        this.activeModal.close()
      }
      else {
        this.toaster.error(res.message)
      }
    })
  }

 getAllCategory() {
  this.categoryService.getAllCategory().subscribe((res =>{
    if(res.isSuccess) {
      this.categories = res?.response;
    }
  }))
 }


}
